// Skladanie wierszy menu "⋮" posiedzenia (widok posiedzenia, lista wyszukiwarki) wg ukladu z componentsData/sessionViewMenuLayout.js (PRD 4.3):
// - grupa bez widocznych akcji znika, z jedna akcja to zwykly wiersz, z dwiema i wiecej ma podmenu;
// - widoczne akcje spoza ukladu ida w miejsce znacznika "fallback" w kolejnosci z katalogu (meetingsActions.js), kazda raz;
// - separatory sa redukowane na koncu, a pozostaly zamienia sie w borderline na nastepnym wierszu.
// Zwraca wiersze oraz id do ostrzezen w trybie deweloperskim: fallbackIds (akcje spoza ukladu)
// i unknownIds (id z ukladu, ktorych nie ma w katalogu).
export function buildMenuEntries(layoutItems, visibleActions, catalog) {
    const visible = new Map();
    visibleActions.forEach(item => {
        visible.set(item.id, item);
    });
    const catalogIds = new Set(catalog.map(item => item.id));
    const unknownIds = [];
    const checkKnown = id => {
        if (!catalogIds.has(id) && unknownIds.indexOf(id) === -1) {
            unknownIds.push(id);
        }
    };
    const used = new Set();
    const actionEntry = item => ({ type: "action", key: "action-" + item.id, action: item });
    const rows = [];
    let fallbackIndex = -1;
    layoutItems.forEach(element => {
        if (element.type === "action") {
            checkKnown(element.id);
            if (visible.has(element.id) && !used.has(element.id)) {
                used.add(element.id);
                rows.push(actionEntry(visible.get(element.id)));
            }
        }
        else if (element.type === "group") {
            const groupActions = [];
            element.actionIds.forEach(id => {
                checkKnown(id);
                if (visible.has(id) && !used.has(id)) {
                    used.add(id);
                    groupActions.push(visible.get(id));
                }
            });
            if (groupActions.length === 1) {
                rows.push(actionEntry(groupActions[0]));
            }
            else if (groupActions.length > 1) {
                rows.push({ type: "group", key: "group-" + element.id, id: element.id, name: element.name, icon: element.icon, actions: groupActions });
            }
        }
        else if (element.type === "separator") {
            rows.push({ type: "separator" });
        }
        else if (element.type === "fallback" && fallbackIndex === -1) {
            fallbackIndex = rows.length;
        }
    });

    const fallback = catalog.filter(item => visible.has(item.id) && !used.has(item.id));
    rows.splice(fallbackIndex === -1 ? rows.length : fallbackIndex, 0, ...fallback.map(actionEntry));

    const entries = [];
    let pendingBorder = false;
    rows.forEach(row => {
        if (row.type === "separator") {
            pendingBorder = entries.length > 0;
            return;
        }
        row.borderline = pendingBorder;
        pendingBorder = false;
        entries.push(row);
    });
    return { entries, fallbackIds: fallback.map(item => item.id), unknownIds };
}
